export default "https://assets.egbcdn.net/assets/packs/_/sounds/incubator_bet_max-cf6e5150a53ee2147d5bade8ae51694d.mp3";